/**
 * Blog authors keyed by id. Posts reference authorId in {@link ../blog/postsMeta.js}.
 * Add a row here once per contributor; each post picks an author without duplicating bio HTML.
 *
 * CommonJS exports so Node prerender can require(); CRA still imports via webpack interop.
 */
const BLOG_AUTHORS = {
  'vanessa-mosbacker': {
    id: 'vanessa-mosbacker',
    name: 'Vanessa Mosbacker',
    /** Byline + author bio card use the same headshot */
    bylineAvatarSrc: '/images/blog/vanessa-profile.png',
    bioPhotoSrc: '/images/blog/vanessa-profile.png',
    aboutPath: '/about',
    /** Role line inside pink bio card */
    bioRoleLabel: 'Founder & CEO, OrivonAI',
    /** Prefix before middot + date in top byline */
    bylineRolePrefix: 'Founder & CEO',
    bioParagraph:
      "Vanessa is the founder and CEO of OrivonAI, the platform she wished she'd had during her own seven-year fertility journey. Before OrivonAI, she spent her career in marketing at tech giants across Silicon Valley. She lives with her husband, stepson and two children in New Albany, Ohio.",
  },
};

module.exports = { BLOG_AUTHORS };
